var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnStdntmenuToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5674 0.00195312H42.2676L49.6895 12.8564L42.2676 25.7109H38.5674V25.7197H17.5674V25.7109H7.42188L0 12.8564L7.42188 0.00195312H17.5674V0H38.5674V0.00195312Z",
    fill: "#BBFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6603 4L39.6603 4L44.6603 12.6603L39.6603 21.3205L29.6603 21.3205L24.6603 12.6603L29.6603 4Z",
    fill: "#090909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnStdntmenuToggleOn);
export default __webpack_public_path__ + "static/media/btn-stdntmenu-toggle-on.a24f963798cb62ed323415e62b1f57c5.svg";
export { ForwardRef as ReactComponent };